import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-completion-page',
  standalone: true,
  imports: [LocalizationPipePipe, DatePipe],
  templateUrl: './completion-page.component.html',
  styleUrls: ['./completion-page.component.scss']
})
export class CompletionPageComponent {
  @Input() submissionId = '';
  @Input() formTitle = '';
  @Input() submittedAt: Date = new Date();

  @Output() submitAnother = new EventEmitter<void>();

  onSubmitAnother(): void {
    this.submitAnother.emit();
  }
}
